import { render, staticRenderFns } from "./ChangeCourse.vue?vue&type=template&id=6ab00e8c&scoped=true&"
import script from "./ChangeCourse.vue?vue&type=script&lang=js&"
export * from "./ChangeCourse.vue?vue&type=script&lang=js&"
import style0 from "./ChangeCourse.vue?vue&type=style&index=0&id=6ab00e8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab00e8c",
  null
  
)

export default component.exports